__turbopack_context__.v({
  "blok-big-title": "ArticleCardBlok-module__e1xKYW__blok-big-title",
  "blok-subtitle": "ArticleCardBlok-module__e1xKYW__blok-subtitle",
  "blok-title": "ArticleCardBlok-module__e1xKYW__blok-title",
  "card__image": "ArticleCardBlok-module__e1xKYW__card__image",
  "card__skeleton": "ArticleCardBlok-module__e1xKYW__card__skeleton",
  "description": "ArticleCardBlok-module__e1xKYW__description",
  "description__wrapper": "ArticleCardBlok-module__e1xKYW__description__wrapper",
  "featured": "ArticleCardBlok-module__e1xKYW__featured",
  "heading": "ArticleCardBlok-module__e1xKYW__heading",
  "image": "ArticleCardBlok-module__e1xKYW__image",
  "slideshow": "ArticleCardBlok-module__e1xKYW__slideshow",
  "tag": "ArticleCardBlok-module__e1xKYW__tag",
});
